module.exports = __webpack_public_path__ + "static/img/confirm-ban.8278be46.png";